import styles from "./index.module.less";
import logo from "./images/logo.png";
import logo1 from "./images/logo1.png";
import middleRight from "./images/middleRight.png";
import arrowPng from "./images/arrow.png";
import arrow2Png from "./images/arrow2.png";
import { Collapse, Input, Progress, Spin, Dropdown } from "@douyinfe/semi-ui";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import disconectPng from "./images/disconect.png";
import Countdown from "react-countdown";
import dayjs from "dayjs";
import {
  useContractRead,
  useContractWrite,
  useAccount,
  useDisconnect,
} from "wagmi";
import { parseEther } from "viem";
import { ABI } from "./abi";
import { useEffect, useRef, useState } from "react";
import { Notification } from "@douyinfe/semi-ui";
import React from "react";
import classNames from "classnames";
import BigNumber from "bignumber.js";
import { IconRedoStroked } from "@douyinfe/semi-icons";
import {
  bascScanUrl,
  contractAddress,
  onAddressAbbreviation,
  day,
  mintTime,
} from "utils/util";
import { useCountDown, useUpdate } from "ahooks";
const Home = () => {
  const [isMobile, setIsMobile] = React.useState(false);
  const [iscontractMints, setIscontractMints] = useState(0);
  const [addressMaxMintNums, setAddressMaxMintNums] = useState(5);
  const [isAddressMintNums, setIsAddressMintNums] = useState(0);
  const [type, setType] = useState<0 | 1>(0);
  const { address } = useAccount();
  const { disconnect } = useDisconnect();
  useEffect(() => {
    const mobileRegex =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    try {
      if (mobileRegex.test(navigator.userAgent)) {
        setIsMobile(true);
      }
    } catch (e) {}
  }, []);
  const [mintPrice, setCurrentPrice] = useState(0.0005);
  const [maxSupply, setMaxSupply] = useState(10000);
  const [mintAmount, setMintAmount] = useState("1");
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);
  const [loading2, setLoading2] = useState(false);

  const totalPrice = new BigNumber(mintPrice)
    .multipliedBy(mintAmount || 0)
    .toFormat();

  const { writeAsync: contractMint } = useContractWrite({
    // @ts-ignore
    address: contractAddress,
    // @ts-ignore
    abi: ABI,
    // @ts-ignore
    functionName: "mint",
    // @ts-ignore
    args: [1],
    // @ts-ignore
    value: parseEther(totalPrice),
  });
  const update = useUpdate();

  // useCountDown({
  //   targetDate: mintTime().toDate(),
  //   onEnd: () => {
  //     update();
  //   },
  // });
  console.log("mintTime().toDate()", mintTime().toDate());
  const canNotMint =
    mintTime().toDate().getTime() >= day(dayjs()).toDate().getTime();
  console.log(canNotMint, "canNotMint");
  const disabledMint = loading || isAddressMintNums === 5 || canNotMint;
  const onMint = async () => {
    try {
      if (loading) return;
      if (canNotMint) {
        Notification.error({
          title: "Mint Failed",
          content: "Mint time has not arrived",
          duration: 3,
        });
        return;
      }
      if (
        isAddressMintNums === addressMaxMintNums ||
        Number(mintAmount) > addressMaxMintNums
      ) {
        Notification.error({
          title: "Mint Failed",
          content: `Max ${addressMaxMintNums} mint per wallet`,
          duration: 3,
        });
        return;
      }
      if (!mintAmount) {
        inputRef.current?.focus();
        Notification.error({
          title: "Mint Failed",
          content: "Please enter the number of mint.",
          duration: 3,
        });
        setLoading(false);
        return;
      }

      setLoading(true);
      const result = await contractMint();
      refetch();
      Notification.success({
        title: "Transfer Success",
        content:
          "The transfer operation has been executed. Click to view details.",
        duration: 5,
        className: styles.notification,
        onClick: () => {
          window.open(`${bascScanUrl}/tx/${result.hash}`);
        },
      });
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      const errMsg = e.message;
      if (errMsg.indexOf("Exceeds maximum supply") > -1) {
        Notification.error({
          title: "Mint Failed",
          content: "Exceeds maximum supply",
          duration: 3,
        });
        return;
      }
      if (errMsg.indexOf("The contract function") > -1) {
        Notification.error({
          title: "Mint Failed",
          content: "Please check the wallet for a mint operation",
          duration: 3,
        });
        return;
      }
      if (errMsg.indexOf("User rejected the request") > -1) {
        Notification.error({
          title: "Mint Failed",
          content: "User rejected transaction",
          duration: 3,
        });
        return;
      }
      if (errMsg.indexOf("Missing or invalid parameters") > -1) {
        Notification.error({
          title: "Mint Failed",
          content: "Missing or invalid parameters",
          duration: 3,
        });
        return;
      }
    }
  };
  const refetch = () => {
    refetchBalanceOf();
    refetchSupply();
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      refetchSupply();
    }, 3000);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  const { data: balanceOf, refetch: refetchBalanceOf } = useContractRead({
    address: contractAddress,
    abi: ABI,
    functionName: "balanceOf",
    args: [address],
  });
  const { data: mintedAmountRes, refetch: refetchSupply } = useContractRead({
    address: contractAddress,
    abi: ABI,
    functionName: "_supply",
  });

  // const { data: maxSupplyRes } = useContractRead({
  //   address: contractAddress,
  //   abi: ABI,
  //   functionName: "maxSupply",
  // });

  // const { data: mintPriceRes } = useContractRead({
  //   address: contractAddress,
  //   abi: ABI,
  //   functionName: "mintPrice",
  // }) as any;
  useEffect(() => {
    if (mintedAmountRes) {
      setIscontractMints(Number(mintedAmountRes || 0));
    }
    if (balanceOf) {
      setIsAddressMintNums(Number(balanceOf) || 0);
    }
  }, [balanceOf, mintedAmountRes]);

  return (
    <div
      className={classNames(styles.contain, {
        [styles.mobile]: isMobile,
      })}
    >
      <>
        <header>
          <div className={styles.left}>
            <img src={logo1} alt="" className={styles.logo1} />
            <div> MerlinPrincess</div>
          </div>
          <div className={styles.right}>
            <div
              className={styles.follow}
              onClick={() => {
                window.open("https://twitter.com/MerlinPrincess_");
              }}
            >
              Follow On
              <div
                className={styles.tg}
                onClick={() => {
                  window.open("https://twitter.com/MerlinPrincess_");
                }}
              ></div>
            </div>
            <div className={styles.wallet}>
              {address ? (
                <>
                  {onAddressAbbreviation(address)}
                  <img
                    src={disconectPng}
                    alt=""
                    onClick={() => disconnect()}
                    className={styles.operatRight}
                  />
                </>
              ) : (
                <ConnectButton.Custom>
                  {({
                    account,
                    chain,
                    openAccountModal,
                    openChainModal,
                    openConnectModal,
                    mounted,
                  }) => {
                    return (
                      <div
                        className={styles.btn}
                        onClick={() => {
                          openConnectModal();
                        }}
                      >
                        Connect Wallet
                      </div>
                    );
                  }}
                </ConnectButton.Custom>
              )}
            </div>
          </div>
        </header>
        <div className={styles.middle}>
          <div className={styles.middleLeft}>
            <img src={logo} alt="" />
            <div className={styles.leftText}>
              Merlin Princess is a unique collection of MRC404, representing a
              distinctive aesthetic and unparalleled value. These NFTs not only
              embody art but also a spirit of pursuing dreams and bravely facing
              the unknown.
              <br />
              <br />
              In the story of Merlin Princess, each princess has her own tale
              filled with adventure, challenges, and growth. Similar to
              characters in these stories, each NFT possesses its unique
              personality, story, and value.
            </div>
          </div>
          <div className={styles.middleRight}>
            <img src={middleRight} alt="" />
          </div>
        </div>
      </>
      <div className={styles.timebox}>
        {canNotMint && (
          <Countdown className={styles.time} date={mintTime().toDate()} />
        )}
      </div>
      <div className={styles.mint}>
        <div className={styles.mintBox}>
          <div className={styles.tittleTop}>
            {type === 0 && (
              <>
                <div className={styles.h1}>
                  <div>MINT</div>
                  <div className={styles.flesh}>
                    <span>{iscontractMints}</span>
                    <span>/{"10,000"}</span>
                    <div
                      onClick={() => {
                        if (loading2) return;
                        setLoading2(true);
                        refetch();
                        setTimeout(() => {
                          setLoading2(false);
                        }, 600);
                      }}
                    >
                      <IconRedoStroked />
                    </div>
                  </div>
                </div>

                <Progress
                  percent={
                    iscontractMints === 0
                      ? 0
                      : (Math.floor(Number(iscontractMints)) /
                          Number(maxSupply)) *
                        100
                  }
                />

                {
                  <div className={styles.progressNum}>
                    {iscontractMints === 0
                      ? ""
                      : `${
                          (Math.floor(Number(iscontractMints)) /
                            Number(maxSupply)) *
                          100
                        }%`}
                  </div>
                }

                <div className={styles.contaiText}>
                  <div>Supply</div>
                  <div className={styles.div2}>{"10,000"}</div>
                </div>
                <div className={styles.contaiText}>
                  <div>Mint Price</div>
                  <div className={styles.div2}>{mintPrice}BTC</div>
                </div>

                <div className={styles.contaiText}>
                  <div>Amounts</div>
                  <div>
                    <Input
                      value={mintAmount}
                      onChange={(value) => {
                        if (/^([1-9]|10)$/.test(value) || value === "") {
                          setMintAmount(value);
                        }
                      }}
                      min={1}
                      max={addressMaxMintNums}
                      defaultValue={1}
                      ref={inputRef}
                    />
                  </div>
                </div>
                <div className={styles.contaiText}>
                  <div>Max Mint Per Address</div>
                  <div className={styles.div2}>{addressMaxMintNums}</div>
                </div>
              </>
            )}

            {address ? (
              type === 0 ? (
                <div
                  className={classNames(styles.btn, [
                    {
                      [styles.btnDisable]: disabledMint,
                    },
                  ])}
                  onClick={onMint}
                >
                  {loading ? <Spin size="small" /> : null}
                  {loading
                    ? "Minting..."
                    : Number(isAddressMintNums) === 5
                    ? `Max ${addressMaxMintNums} mint per wallet`
                    : canNotMint
                    ? "Mint time has not arrived"
                    : "Mint"}
                </div>
              ) : (
                ""
              )
            ) : (
              <ConnectButton.Custom>
                {({
                  account,
                  chain,
                  openAccountModal,
                  openChainModal,
                  openConnectModal,
                  mounted,
                }) => {
                  return (
                    <div
                      className={styles.btn}
                      onClick={() => {
                        openConnectModal();
                      }}
                    >
                      Connect Wallet
                    </div>
                  );
                }}
              </ConnectButton.Custom>
            )}
            <div className={styles.minTime}>
              Mint Starts March 10 at 12:00 PM UTC
            </div>
          </div>
        </div>
      </div>

      <div className={styles.progress}>
        <Collapse
          expandIcon={<img src={arrowPng} alt="" />}
          collapseIcon={<img src={arrow2Png} alt="" />}
        >
          <Collapse.Panel
            header="Q1: What are the sales rules for Princess Merlin?"
            itemKey="1"
          >
            <div>
              Mint Price: 0.0005 BTC <br />
              <br />
              Total Supply: 10,000
              <br /> <br />
              Single Wallet Mint Limit: 5 <br />
              <br />
              Mint Time: 12:00 on March 10, 2024, UTC
            </div>
          </Collapse.Panel>
          <Collapse.Panel
            header="Q2: What will the sales funds be used for?"
            itemKey="2"
          >
            <div>
              50% of the sales amount will be used to place offers for NFTs at a
              price of 0.0005 BTC. The remaining 50% will be entirely used for
              adding to the token pool, which will be locked for 100 years.
              Transaction fees will be used entirely for token buybacks, with
              updates shared publicly on a weekly basis.
            </div>
          </Collapse.Panel>
          <Collapse.Panel
            header="Q3: How many sets of Princess Merlin series NFTs will there be?"
            itemKey="3"
          >
            <div>
              There will be a total of 5 sets of Princess Merlin series NFTs,
              representing collections from 5 different tribes in the Merlin
              world. This collection will serve as the OG NFT for the entire
              series, granting whitelist eligibility for future NFT collections'
              Freemint.
            </div>
          </Collapse.Panel>
        </Collapse>
      </div>
      <footer>
        <div className={styles.footerBox}>
          <div>Copyright © 2024. MerlinPrincess All rights reserved.</div>
          <div>
            <div
              className={styles.tg}
              onClick={() => {
                window.open("https://twitter.com/MerlinPrincess_");
              }}
            ></div>
          </div>
        </div>
      </footer>
    </div>
  );
};
export default Home;
